<section class="main-container d-flex flex-column justify-content-center align-items-center h-100 position-relative">
  <app-bubbles-bg></app-bubbles-bg>
  <div class="header-website">
    <div (click)="redirectFromSignin()" class="close-image">
      <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/431981c1762867455585Group_1707482656.svg"
        alt="back_arrow" class="back_arrow" />
    </div>
  </div>
  <div class="d-flex justify-content-center align-items-center h-88 mb-4">
    <div class="signin_right_section h-100">
      <div class="right-parent d-flex flex-column h-100">
        <div class="right-section-heading mb-1">Everything you need to succeed</div>
        <div class="right-section-sub-text">Powerful AI tools to grow your business</div>
        <div class="products row mt-2 gap-8-15">
          <ng-container *ngFor="let product of features">
            <div class="product col-4 d-flex align-items-center justify-content-center flex-column mb-2">
              <div class="product-icon mb-2">
                <img [src]="product.icon" alt="product_icon" />
              </div>
              <div class="product-details text-center">
                <div class="product-title mb-1">{{ product.title }}</div>
                <div class="product-subtitle">{{ product.description }}</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="formType === 'SIGN_UP'"
      class="signup_section d-flex flex-column align-items-center w-50 position-relative h-100">
      <div class="panel-divider"></div>
      <div class="signup-left-section d-flex align-items-center justify-content-center w-100 h-100">
        <div class="login_body">
          <div class="section_title">Welcome! Lets build your business</div>
          <div class="section_subtitle">Create your free account today</div>
          <form [formGroup]="signupForm">
            <div class="fields">
              <div class="field">
                <div class="label">Full Name<span class="required">*</span></div>
                <input formControlName="name" matInput placeholder="Enter Your Full Name"
                  class="login-email-input w-100" />
              </div>
              <div class="field">
                <div class="label">Mobile Number<span class="required">*</span></div>
                <div class="code_number">
                  <div class="country_code">
                    <select formControlName="dialCode" class="w-100 h-100">
                      <option *ngFor="let item of countryCodes" [value]="item.shortCode">
                        {{ item.name }}({{ item.dialingCode }})
                      </option>
                    </select>
                  </div>
                  <div class="mobile_number">
                    <input formControlName="mobileNumber" matInput onKeyPress="if(this.value.length==15) return false;"
                      pattern="^[6-9]\d{9}$|^[1-9]\d{9}$" placeholder="Enter Your Mobile Number" type="number"
                      class="login-email-input w-100" />
                  </div>
                </div>
              </div>

              <div class="field">
                <div class="label">Email Address<span class="required">*</span></div>
                <input (input)="onEmailChange($event)" formControlName="email" matInput
                  placeholder="Enter Email Address" class="login-email-input w-100" />
              </div>
              <div class="field">
                <div class="label">Password<span class="required">*</span></div>
                <div class="d-flex w-100 login-password-input align-items-center">
                  <input (blur)="hide()" [type]="signupHide ? 'password' : 'text'" formControlName="password" id="focus"
                    matInput maxlength="16" minlength="8" placeholder="Enter Password" class="w-100" />
                  <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/181720c1762866309854Icon_(3).svg" alt=""
                    *ngIf="!signupHide" (click)="signupHide = !signupHide"
                    style="cursor: pointer; height:20px; width:20px;" />

                  <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/994914c1762805529071Eye_off.svg" alt=""
                    *ngIf="signupHide" (click)="signupHide = !signupHide"
                    style="cursor: pointer; height:20px; width:20px;" />

                </div>
                <div class="password_length" style="font-size: 12px !important;">
                  <div style="display:flex;justify-content: space-between; font-size: small;">
                    <div
                      [ngClass]="{'success_text': !signupForm.get('password')?.errors || signupForm.get('password')?.errors?.['oneNumberPattern']}"
                      class="validation" id="number">
                      <li style="font-size: small">At least One Numeric</li>
                    </div>
                    <div
                      [ngClass]="{'success_text': !signupForm.get('password')?.errors || signupForm.get('password')?.errors?.['minimumLength']}"
                      class="validation" id="min_length" style="font-size: small;">
                      <li style="font-size: small">8 Characters Minimum</li>
                    </div>
                  </div>
                  <div style="display:flex;justify-content: space-between; font-size: small;">
                    <div
                      [ngClass]="{'success_text': !signupForm.get('password')?.errors || signupForm.get('password')?.errors?.['oneLetterCapital']}"
                      class="validation" id="capital" style="font-size: small;">
                      <li style="font-size: small">At least One Letter Uppercase</li>
                    </div>
                    <div
                      [ngClass]="{'success_text': !signupForm.get('password')?.errors || signupForm.get('password')?.errors?.['oneSymbolPattern']}"
                      class="validation" id="special_character" style="font-size: small;">
                      <li style="font-size: small">One Special Character</li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="term_conditions">
              By clicking "Create an account" you agree to simpo.ai <span (click)="privacyPolicy()"
                style="cursor: pointer;">Privacy Policy</span>
              and <span (click)="termsConditions()" style="cursor: pointer;">Terms and Conditions</span>.
            </div>
            <div class="continue_btn">
              <button (click)="activeTab == 'OLD_FLOW' ? createAnAccount() : createAnAccountNew()" *ngIf="!loader"
                [disabled]="!signupForm.valid" [ngClass]="{'disable-btn': !signupForm.valid}">
                <span>Create an account</span>
              </button>
              <button *ngIf="loader">
                <span class="spinner">
                  <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading
                </span>
              </button>
            </div>
          </form>
          <div class="alrea_account">
            Already have an account? <span (click)="redirectToSignIn()" style="cursor: pointer;">Sign
              In</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="formType === 'LOGIN'"
      class="signup_section  d-flex flex-column align-items-center w-50 position-relative h-100">
      <div class="panel-divider"></div>
      <div class="signup-left-section d-flex align-items-center justify-content-center w-100 h-100">
        <div class="login_body">
          <div class="section_title">Welcome back!</div>
          <div class="section_subtitle">Log in to your simpo.ai account</div>
          <form [formGroup]="signInForm">
            <div class="fields">
              <div class="field">
                <div class="label mb-1">Email Address <span class="required">*</span></div>
                <input (input)="onEmailChange($event)" formControlName="email" matInput
                  placeholder="Enter Email Address" class="login-email-input w-100" />
              </div>
              <div class="field">
                <div class="label mb-1">Password <span class="required">*</span></div>
                <div class="d-flex w-100 login-password-input align-items-center">
                  <input (keyup.enter)="login()" [type]="signinHide ? 'password' : 'text'" formControlName="password"
                    matInput placeholder="Enter Password" class="w-100" />
                  <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/181720c1762866309854Icon_(3).svg" alt=""
                    *ngIf="!signinHide" (click)="signinHide = !signinHide"
                    style="cursor: pointer; height:20px; width:20px;" />

                  <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/994914c1762805529071Eye_off.svg" alt=""
                    *ngIf="signinHide" (click)="signinHide = !signinHide"
                    style="cursor: pointer; height:20px; width:20px;" />

                </div>
                <div class="remember_forget">
                  <div class="remeber">
                    <mat-checkbox class="example-margin" color="primary" formControlName="rememberMe">Remember
                      me
                    </mat-checkbox>
                  </div>
                  <div (click)="forgotPassword()" class="forgot_password">Forgot password?</div>
                </div>
              </div>
            </div>
            <div class="continue_btn d-flex justify-content-center">
              <button (click)="login()" *ngIf="!loader" [disabled]="!signInForm.valid"
                [ngClass]="{'disable-btn': !signInForm.valid}">
                <span>Login</span>
              </button>
              <button *ngIf="loader">
                <span class="spinner">
                  <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading
                </span>
              </button>
            </div>
            <div class="alrea_account">
              No account yet? <span (click)="changeTab()" style="cursor: pointer;">Sign Up</span>
              <!-- (click)="redirectToSignup()"  -->
            </div>
            <div class="continue-with">
              <hr>
              <div style="color: rgba(107,114,128,var(1));text-align: center;white-space: nowrap;">Or Continue with
              </div>
              <hr>
            </div>
            <div class="alrea_account" style="display: flex;justify-content: center;margin-top: 15px;">
              <asl-google-signin-button GoogleSigninButtonDirective shape='rectangular' size='large'
                type='standard'></asl-google-signin-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- <div>
          <div class="button-tabs-group" role="group" aria-label="Flow selection">
            <button *ngFor="let tab of tabs" type="button" [class]="'btn-tab' + (activeTab === tab.id ? ' active' : '')"
              (click)="switchTab(tab.id)" [attr.aria-pressed]="activeTab === tab.id">
              {{ tab.label }}
            </button>
          </div>
        </div> -->